import type { FlightRealizationEnum } from '@features/regional-overview/digital-traps/domain/flight-stage.enum';
import { useTranslation } from 'react-i18next';
import { FlightRealizationText, FlightStageContainer, FlightStageText } from './flight-stage-tag.style';
import { getFlightStageColors } from './flight-stage-tag.utils';

interface FlightStageTagProps {
  flightGeneration: string;
  flightStage: FlightRealizationEnum;
}

const FlightStageTag = ({ flightGeneration, flightStage }: FlightStageTagProps) => {
  const [t] = useTranslation();
  const { backgroundColor, borderColor } = getFlightStageColors(flightStage.toUpperCase());

  return (
    <FlightStageContainer backgroundColor={backgroundColor} borderColor={borderColor}>
      <FlightStageText>{flightGeneration.toUpperCase()}:</FlightStageText>
      <FlightRealizationText>{t(`pages.regional_overview.digital_traps.flight_stage.${flightStage.toLowerCase()}`)}</FlightRealizationText>
    </FlightStageContainer>
  );
};

export default FlightStageTag;
